import React from 'react';

import ProductPlaceholder from '../../../../assets/productPlaceholder.jpg';

const PlaceholderImage = ({ productName, onClick, className }) => (
  <img
    width="752"
    height="940"
    src={ProductPlaceholder ?? 'product-placeholder'}
    alt={productName}
    onClick={onClick && onClick}
    className={className}
  />
);

export default PlaceholderImage;
